import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportLoanListingByLoanStatus from "../reports/ReportLoanListingByLoanStatus";


function LoanListingByLoanStatus() {
    return (
        <>
            <NavMain slug="loan-listing-by-loan-status" parent="4" />
            <HeaderMain slug="loan-listing-by-loan-status" />
            <div className="main-content">
                <ReportLoanListingByLoanStatus />
            </div>
        </>
    );
}

export default LoanListingByLoanStatus;